/**
 * Extracts IDs from various Payload relationship formats
 */
export function extractId<T extends { id: number }>(
  relation: number | T | null | undefined,
): number | null {
  if (!relation) return null
  return typeof relation === 'object' ? relation.id : relation
}

export function extractIdNotNull<T extends { id: number }>(relation: number | T): number {
  return typeof relation === 'object' ? relation.id : relation
}

/**
 * Builds a Payload query to find a node by either id or externalId
 * Handles both numeric IDs and external IDs (strings)
 *
 * @param nodeId - The node identifier (can be numeric id or external id string)
 * @returns Query conditions for Payload find operations
 */
export function buildNodeIdQuery(nodeId: string): Array<Record<string, any>> {
  // Check if nodeId is a valid integer (for id field) or should be treated as externalId
  const nodeIdNum = parseInt(nodeId)
  const isValidId = !isNaN(nodeIdNum) && nodeIdNum.toString() === nodeId && nodeIdNum <= 2147483647 // PostgreSQL integer max

  // Build query conditions based on whether nodeId is a valid integer
  if (isValidId) {
    // If it's a valid integer, search by both id and externalId
    return [
      {
        id: {
          equals: nodeIdNum,
        },
      },
      {
        externalId: {
          equals: nodeId,
        },
      },
    ]
  } else {
    // If it's not a valid integer (too large or not numeric), only search by externalId
    return [
      {
        externalId: {
          equals: nodeId,
        },
      },
    ]
  }
}
